import React, { useEffect, useState, Fragment } from 'react';

import { motion } from 'framer-motion';
import { wstepy } from '../../functions/motions.js';
import { getTablicaPrzelewy2, getTablicaCzynsze2 } from '../../functions/tablice.js';
import { znajdzAktualny } from '../../functions/stawki.js';

import MieszkaniecDaneInformacje from './MieszkaniecDaneInformacje.js';
import MieszkaniecDaneHistoriaWplat from './MieszkaniecDaneHistoriaWplat.js';
import MieszkaniecDaneGrupy from './MieszkaniecDaneGrupy.js';
import MieszkaniecDaneWoda from './Woda/MieszkaniecDaneWoda.js';
import MieszkaniecDaneDodajGrupe from './MieszkaniecDaneDodajGrupe.js';
import MieszkaniecDaneNaleznosci from './MieszkaniecDaneNaleznosci.js';
import MieszkaniecDaneSaldo from './MieszkaniecDaneSaldo.js';
import MieszkaniecDaneStawkiInd from './MieszkaniecDaneStawkiInd.js';
import MieszkaniecWydruk from '../Mieszkaniec/Wydruk/MieszkaniecWydruk.js';

import Loader from '../Loader.js';
import { rrrr_mm_dd_to_mm_rrrr } from '../../functions/dataFormat.js';
import { isArray, isObject, isTable } from '../../functions/utilities.js';
import { isAfter } from 'date-fns';

const MieszkaniecDane = (props) => {

    const { wspolnotaArr, przelewy, mieszkaniec, mieszkaniecAll, udzialyKontaAkt, lokale, ulice, stawkiJednorazowe, 
        stawkiJednorazoweInd, stawkiInd, wspolnota, editDataOd, setEditDataOd, editDataDo, setEditDataDo, 
        user, grupaUdzial, grupy_g, taGrupaUdzial, ulicaId, addGrupe, setAddGrupe, imie, setImie, email, setEmail, telefon, 
        setTelefon, stawki, nota, setNota, zarzad, setZarzad, notaDane, setNotaDane, wybranyOdczyt, setWybranyOdczyt, tablicaCzynsze, rozliczenieWody
    } = props; 
    
    const [zmianyMieszkancaPokaz, setZmianyMieszkancaPokaz] = useState( false );

    const [tablicaCzynsze_g, setTablicaCzynsze_g] = useState(undefined);
    const [tablicaPrzelewy, setTablicaPrzelewy] = useState(undefined);
    const [tablicaPrzelewy_g, setTablicaPrzelewy_g] = useState(undefined);
    const [udzialyKontaAkt_u, setUdzialyKontaAkt_u] = useState([]);
    const [stawkiInd_g, setStawkiInd_g] = useState([]);
    const [stawkiJednorazoweInd_u, setStawkiJednorazoweInd_u] = useState([]);

    const [loaderOn, setLoaderOn] = useState(false);
    const [msc, setMsc] = useState("");
    const [czyWydruk, setCzyWydruk] = useState(false);
    const [stawkiOst, setStawkiOst] = useState([]);

    const [wybraneRozliczenieWody, setWybraneRozliczenieWody] = useState([]);

    useEffect( () => setWybraneRozliczenieWody( rozliczenieWody?.find( r => r?.miesiac == msc /*&& r?.opublikowany == 1*/) ));

    useEffect( () => setUdzialyKontaAkt_u( udzialyKontaAkt?.filter( u => u?.id_user == mieszkaniec?.id_user)), [udzialyKontaAkt, mieszkaniec]);
    useEffect( () => setStawkiInd_g(stawkiInd?.filter( s => s?.id_user == grupaUdzial?.id_user && s?.grupa_numer == grupaUdzial?.grupa_numer)),[stawkiInd, grupaUdzial]);
    
    const showPrint = () => setCzyWydruk( prevState => !prevState );
    useEffect( () => setStawkiOst(znajdzAktualny(stawki, msc)), [msc, stawki]);

    useEffect( () => setStawkiJednorazoweInd_u( stawkiJednorazoweInd?.filter( s => s?.id_user == mieszkaniec?.id_user
        && s?.grupa_numer == grupaUdzial?.grupa_numer
        && rrrr_mm_dd_to_mm_rrrr(s?.msc) == msc
     )), [stawkiJednorazoweInd, mieszkaniec, msc]);

    useEffect( () => {
        if (tablicaCzynsze?.length > 0) {
            const u = tablicaCzynsze?.find( t => t?.id_user == grupaUdzial?.id_user)?.grupy_udzial_msc;
            const g = u?.find( u => u?.grupa_numer == grupaUdzial?.grupa_numer)
            setTablicaCzynsze_g( g ? g?.temp_msc : [] )
        } else 
            setTablicaCzynsze_g([]);
    },[tablicaCzynsze, grupaUdzial]);
 
    useEffect( () => {
        const temp = getTablicaPrzelewy2(wspolnotaArr, udzialyKontaAkt_u, przelewy)[0];
        if (temp?.length > 0)
            setTablicaPrzelewy( temp[0].grupy );
        else
            setTablicaPrzelewy([]);
    },[ wspolnotaArr, udzialyKontaAkt_u, przelewy]); 

    useEffect( () => setTablicaPrzelewy_g( tablicaPrzelewy?.length > 0 ? tablicaPrzelewy?.find( t => t?.nr_grupyUdzial == grupaUdzial?.grupa_numer && t?.id_user == grupaUdzial?.id_user) : {}  ), [tablicaPrzelewy, grupaUdzial]);

    useEffect( () => setLoaderOn( isArray(tablicaCzynsze_g) && isObject(tablicaPrzelewy_g) ? false : true ), [tablicaCzynsze_g, tablicaPrzelewy_g]);

    return(
        <motion.div 
            className="content mieszkancyDane ramka-inset-shadow"
            variants={wstepy}
            initial="initial"
            animate="animate"
        >
            <div className='lewa'>
                <MieszkaniecDaneInformacje
                    mieszkaniec={mieszkaniec}
                    user={user}
                    mieszkaniecAll={mieszkaniecAll}
                    zmianyMieszkancaPokaz={zmianyMieszkancaPokaz}
                    setZmianyMieszkancaPokaz={setZmianyMieszkancaPokaz}
                    setAddGrupe={setAddGrupe}
                    imie={imie}
                    setImie={setImie}
                    telefon={telefon}
                    setTelefon={setTelefon}
                    email={email}
                    setEmail={setEmail}
                    nota={nota}
                    setNota={setNota}
                    zarzad={zarzad}
                    setZarzad={setZarzad}
                    notaDane={notaDane}
                    setNotaDane={setNotaDane}
                />
                {
                    ulicaId !== -1 && (
                        <Fragment>
                            <MieszkaniecDaneSaldo
                                grupaUdzial={grupaUdzial}
                                tablicaPrzelewy_g={tablicaPrzelewy_g}
                                tablicaCzynsze_g={tablicaCzynsze_g}
                                rozliczenieWody={rozliczenieWody}
                            />
                            <MieszkaniecDaneHistoriaWplat
                                grupaUdzial={grupaUdzial}
                                tablicaPrzelewy_g={tablicaPrzelewy_g}
                            />
                            <MieszkaniecDaneNaleznosci
                                grupaUdzial={grupaUdzial}
                                tablicaCzynsze_g={tablicaCzynsze_g}
                                msc={msc}
                                setMsc={setMsc}
                                showPrint={showPrint}
                                rozliczenieWody={rozliczenieWody}
                                stawkiJednorazoweInd_u={stawkiJednorazoweInd_u}
                            /> 
                        </Fragment>
                    )
                }
            </div>
            {
                <div className='prawa'>
                    {   
                        addGrupe ? (
                            <MieszkaniecDaneDodajGrupe
                                mieszkaniec={mieszkaniec}
                                id_wspolnoty={wspolnota?.id}
                                setAddGrupe={setAddGrupe}
                                ktoraGrupa={udzialyKontaAkt?.filter( u => u?.id_user == mieszkaniec?.id_user)?.length + 1}
                            />
                        ) : (
                            ulicaId !== -1 && grupaUdzial && (
                                <Fragment> 
                                    <MieszkaniecDaneGrupy
                                        mieszkaniec={mieszkaniec}
                                        grupy_g={grupy_g}
                                        grupaUdzial={grupaUdzial}
                                        wspolnota={wspolnota}
                                        editDataOd={editDataOd}
                                        setEditDataOd={setEditDataOd}
                                        editDataDo={editDataDo}
                                        setEditDataDo={setEditDataDo}
                                        taGrupaUdzial={taGrupaUdzial}
                                    />  
                                    <MieszkaniecDaneStawkiInd
                                        grupaUdzial={grupaUdzial}
                                        stawki={stawki}
                                        stawkiInd_g={stawkiInd_g}
                                    />
                                  <MieszkaniecDaneWoda
                                        grupaUdzial={grupaUdzial}
                                        tablicaCzynsze_g={tablicaCzynsze_g}
                                        wybranyOdczyt={wybranyOdczyt}
                                        setWybranyOdczyt={setWybranyOdczyt}
                                        mieszkaniec={mieszkaniec}
                                        grupy_g={grupy_g}
                                        rozliczenieWody={rozliczenieWody}
                                    />
                                </Fragment>
                            ) 
                        )
                    }
                </div>
            }
            <Loader
                stan={loaderOn}
            />
            {czyWydruk && (
                <MieszkaniecWydruk 
                    udzialyKonta_a={grupaUdzial}
                    showPrint={showPrint}
                    mieszkaniec={mieszkaniec}
                    tablicaCzynszeAkt={tablicaCzynsze_g?.find( t => t?.msc == msc)}
                    stawkiOst={stawkiOst}
                    stawkiJednorazowe={stawkiJednorazowe}
                    stawkiJednorazoweInd={stawkiJednorazoweInd_u}
                    lokale={lokale}
                    ulice={ulice}
                    grupy_a={grupy_g}
                    miesiac={msc}
                    grupa_numer={grupaUdzial?.grupa_numer}
                    wybraneRozliczenieWody={wybraneRozliczenieWody}
                />
            )}
        </motion.div>
    )
}

export default MieszkaniecDane;